import Http from "../../services/HTTP";
const GET_BALANCE = "GET_BALANCE";

function getBalanceWaiting() {
    return {
        type : GET_BALANCE,
        get_balance_waiting : true,
        get_balance_response : {},
        get_balance_error : {}
    }
}

function getBalanceSuccess(response) {
    return {
        type: GET_BALANCE,
        get_balance_waiting : false,
        get_balance_response : response,
        get_balance_error : {}
    }
}

function getBalanceError(error) {
    return {
        type : GET_BALANCE,
        get_balance_waiting : false,
        get_balance_response : {},
        get_balance_error : error
    }
}

function getBalance() {
    return (dispatch) => {
        dispatch(getBalanceWaiting());
        const get = Http.GET('pharmacy/v1/balance',{});
        get.then((response) => {
            if (response !== undefined)
                dispatch(getBalanceSuccess(response));
        }).catch((error) => {
            dispatch(getBalanceError(error));
        });
    }
}

export {
    getBalance,
    GET_BALANCE
}
